import React from 'react';
import * as Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as mutationActions from '../../model/action-creators/mutation-actions'
import Editor from './editor/Editor';
import AssLstTable from './AssLstTable';
import {Keys} from '../../model/constants';
import RaisedButton from 'material-ui/RaisedButton';

const workSessionAction = {
    id: 'workSessionAction',
    label: 'W',
    handleSelection: (editorId, selection, currentMutations, dispatch) => {

        const itemSelection = selection; // expect ordered set
        const itemMutations = currentMutations.get(Keys.MutationType.ASSIGNEE); // expect map
        dispatch(mutationActions.doToggleMultiple(
            editorId,
            Keys.MutationType.ASSIGNEE,
            itemSelection,
            itemMutations,
            Keys.Assignee.IN_WORK_SESSION,
            true)
        );
    },
    handleItemClick: (editorId, itemType, item, currentMutations, dispatch) => {
        const mutation = currentMutations.getIn([itemType, item.get(Keys.ID)], Immutable.Map()); // NOTE on not using editorID in path (mutations are already sliced for us)
        dispatch(mutationActions.doTogglePlain(
            editorId,
            itemType,
            item,
            mutation,
            Keys.Assignee.IN_WORK_SESSION,
            true)
        );
    },
    isEnabled: (type, modifiers) => true, // supports all types
    shouldShow: (modifiers) => true, // show regardless of keyboard modifiers
}
const isActiveAction = {
    id: 'isActiveAction',
    label: 'A',
    handleSelection: (editorId, selection, currentMutations, dispatch) => {

        const itemSelection = selection; // expect ordered set
        const itemMutations = currentMutations.get(Keys.MutationType.ASSIGNEE); // expect map
        dispatch(mutationActions.doToggleMultiple(
            editorId,
            Keys.MutationType.ASSIGNEE,
            itemSelection,
            itemMutations,
            Keys.Assignee.ACTIVE,
            true)
        );
    },
    handleItemClick: (editorId, itemType, item, currentMutations, dispatch) => {
        const mutation = currentMutations.getIn([itemType, item.get(Keys.ID)], Immutable.Map()); // NOTE on not using editorID in path (mutations are already sliced for us)
        dispatch(mutationActions.doTogglePlain(
            editorId,
            itemType,
            item,
            mutation,
            Keys.Assignee.ACTIVE,
            true)
        );
    },
    isEnabled: (type, modifiers) => true, // supports all types
    shouldShow: (modifiers) => true, // show regardless of keyboard modifiers
}

const generateGroupAction = (actionId, label, valueToSet) => {
    const prop = Keys.Assignee.GROUPS;
    return {
        id: actionId,
        label: label,
        handleSelection: (editorId, selection, currentMutations, dispatch) => {

            const itemMutations = currentMutations.get(Keys.MutationType.ASSIGNEE); // expect map
            dispatch(mutationActions.doToggleInMultipleSets(
                editorId,
                Keys.MutationType.ASSIGNEE,
                selection,
                itemMutations,
                prop, valueToSet))
        },
        handleItemClick: (editorId, itemType, item, currentMutations, dispatch) => {
            // OR should this be done from the editor?
            const mutation = currentMutations.getIn([itemType, item.get(Keys.ID)], Immutable.Map()); // NOTE on not using editorID in path (mutations are already sliced for us)
            dispatch(mutationActions.doToggleInSet(
                editorId,
                itemType,
                item,
                mutation,
                prop,
                valueToSet)
            );
        },
        isEnabled: (type, modifiers) => true, // supports all types
        shouldShow: (modifiers) => true, // show regardless of keyboard modifiers
    }
}
class AssLstPanel extends React.Component {

    getActions() {
        let actions =  this.props.groups.valueSeq().toJS().map(g => {
            return generateGroupAction('groupAction-'+g.shortName, g.name, g.id)
        });
        if(!this.props.currentWorkSession.isEmpty()) {
            actions.unshift(workSessionAction, isActiveAction);
        }
        return actions;
    }

    render() {
        return (
        <Editor actions={this.getActions()}
                mutations={this.props.mutations}
                editorId={Keys.EditorIds.ASSIGNEE_PAGE}
                dispatch={this.props.dispatch}
                onSave={() => this.props.dispatch(mutationActions.saveEditor(Keys.EditorIds.ASSIGNEE_PAGE))}
        >
            <AssLstTable
                assignees={this.props.assignees}
                groups={this.props.groups}
                mutations={this.props.mutations}
                currentWorkSession={this.props.currentWorkSession}
            />
        </Editor>

        )
    }
}

AssLstPanel.propTypes = {

    assignees:ImmutablePropTypes.map.isRequired,
    groups:ImmutablePropTypes.map.isRequired,
    mutations:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
    dispatch:React.PropTypes.func.isRequired,

};


export default AssLstPanel



// WEBPACK FOOTER //
// ./src/ui/components/AssLstPanel.js